import { render, staticRenderFns } from "./material-box-upload.vue?vue&type=template&id=168f47d7&scoped=true"
import script from "./material-box-upload.vue?vue&type=script&lang=js"
export * from "./material-box-upload.vue?vue&type=script&lang=js"
import style0 from "./material-box-upload.vue?vue&type=style&index=0&id=168f47d7&prod&scoped=true&rel=stylesheet%2Fscss&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "168f47d7",
  null
  
)

export default component.exports